import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IndexingApiService } from '../services/indexing-api.service';

@Component({
  selector: 'app-auto-index-queue',
  templateUrl: './auto-index-queue.component.html',
  styleUrl: './auto-index-queue.component.css'
})
export class AutoIndexQueueComponent {
  showSpinner = true;
  autoIndexQueue: any;
  currentPage: number = 1;
  totalData: number = 0;
  totalPages: number = 0;
  nextSubmission: number = 0;
  lastSubmission: number = 0;


  constructor(private titleService: Title, private indexingApiService: IndexingApiService) {
    this.titleService.setTitle("Auto Index Queue | Rankahead.app");
  }

  ngOnInit() {
    this.nextSubmission = this.getRemainingHours();
    this.lastSubmission = 24 - this.nextSubmission;
    this.changePage(1);
  }

  changePage(currentPage: any) {
    this.showSpinner = true;

    this.indexingApiService.getAutoIndexQueue(currentPage).subscribe((response: any) => {
      this.currentPage = currentPage;
      this.totalData = response.queryCount;
      this.totalPages = Math.ceil(response.totalCount / 50);

      this.autoIndexQueue = response.autoIndexQueue;
      this.showSpinner = false;
    })
  }

  getRemainingHours() {
    let nowStr = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });

    let submissionDateStr = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });

    let submissionDate = new Date(submissionDateStr);

    submissionDate.setHours(1, 0, 0, 0)

    let now = new Date(nowStr);

    if (now.valueOf() > submissionDate.valueOf())
      submissionDate.setDate(submissionDate.getDate() + 1);


    let diffTime = Math.abs(new Date(now).valueOf() - submissionDate.valueOf());
    let days = diffTime / (24 * 60 * 60 * 1000);
    let hours = (days % 1) * 24;
    let minutes = (hours % 1) * 60;
    let secs = (minutes % 1) * 60;
    [days, hours, minutes, secs] = [Math.floor(days), Math.round(hours), Math.round(minutes), Math.round(secs)]

    //console.log(days + 'd', hours + 'h', minutes + 'm', secs + 's');

    return hours;
  }

}
